import logo from './NoOutline.svg';
import './App.css';

const SectionText = ({sectionText}) => {
  return (
    <div className='SectionText'><p>{sectionText}</p></div>
  );
}

export default SectionText;
